import SntCheckIcon from "@icons/SntCheckIcon";
import SntCloseIcon from "@icons/SntCloseIcon";

const CheckView = ({ value }) => {
  if (value === null || value === undefined) "";

  if (typeof value === "boolean") {
    return value ? <SntCheckIcon /> : <SntCloseIcon />;
  }

  if (typeof value === "string") {
    if (value.toUpperCase() === "FALSE") {
      return <SntCloseIcon />;
    } else if (value.toUpperCase() === "TRUE") {
      return <SntCheckIcon />;
    }
  }

  return <>{value}</>;
};

export default CheckView;
